import { Box, Stack, Typography } from '@mui/material'
import Arrow from 'components/Arrow'

export default function Purpose() {
  return (
    <>
      <Box className="py-10 bg-bottom relative">
        <Stack className="absolute inset-0">
          <Box
            component="img"
            src="/static/about-purpose.png"
            alt="about-purpose"
            className="w-full h-full object-cover object-bottom"
          ></Box>
        </Stack>
        <Stack className="container lg:px-[10%] max-w-6xl items-center justify-center relative z-10 mb-[10%]">
          <Typography className="heading-2 min-w-[150px] text-center mb-8 text-[#393F4E]">
            PURPOSE
          </Typography>
          <Stack className="flex-row justify-center w-full lg:gap-2 font-medium lg:tracking-[4px] text-xl drop-shadow-md">
            <h4 className="text-2xl text-[#393F4E] text-center">
              私たち4Sは
              <br className="block sm:hidden" />
              <span className="text-4xl">みんなの幸せ</span>
              <br className="block sm:hidden" />
              を創る会社です​
            </h4>
          </Stack>

          <Stack className="hidden lg:flex flex-row w-full gap-4 font-normal px-1 drop-shadow-md">
            <p>
              みんなの幸せとは、自分の幸福を優先することではなく、自分の視野を広げて全体の幸福を追求することです。ホームコミュニティに属する全員がこの意識を持つことで、持続的に自分もみんなも幸福になることを意味します。​
            </p>
          </Stack>
        </Stack>
      </Box>
      <Stack className="container lg:hidden gap-10 max-w-sm mx-auto my-10">
        <Typography className="text-xl font-semibold">
        みんなの幸せ
        </Typography>
        <Stack className="flex-row items-baseline gap-2">
          <Arrow className="text-[#CDA83F] h-1.5" />
          <Typography className="flex-1">
          自分の幸福を優先することではなく、自分の視野を広げて全体の幸福を追求することです。ホームコミュニティに属する全員がこの意識を持つことで、持続的に自分もみんなも幸福になることを意味します
          </Typography>
        </Stack>
      </Stack>
    </>
  )
}
